import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useHeroSectionStyles } from "./HeroSection.styles";
import { useI18n } from "../../../../i8n/useI18n";
import Reveal from "../../../ui/Reveal";
import SectionEyebrow from "../../../ui/SectionEyebrow";
import { fadeUp } from "../../../../styles/animations";
import { unsplashImageUrl } from "../../../../utils/unsplashImage";

const HeroSection = () => {
    const { classes } = useHeroSectionStyles();
    const { t } = useI18n();

    return (
        <Box className={classes.root}>
            <Box className={classes.imageWrapper}>
                <Box
                    component="img"
                    src={unsplashImageUrl("photo-1609081144289-eacc3108cd03", 1920, 1200)}
                    alt=""
                    className={classes.image}
                />
                <Box className={classes.overlay} />
            </Box>

            <Box className={classes.content}>
                <Reveal variant={fadeUp} delay={0.1}>
                    <SectionEyebrow className={classes.overline} label={t("home.heroSection.overline")} />
                </Reveal>
                <Reveal variant={fadeUp} delay={0.2}>
                    <Typography variant="display1" className={classes.title}>
                        {t("home.heroSection.title")}
                    </Typography>
                </Reveal>
                <Reveal variant={fadeUp} delay={0.3}>
                    <Typography variant="body1" className={classes.subtitle}>
                        {t("home.heroSection.subtitle")}
                    </Typography>
                </Reveal>
                <Reveal variant={fadeUp} delay={0.4}>
                    <Button variant="contained" component={RouterLink} to={t("links.shop")} className={classes.cta}>
                        {t("home.heroSection.cta")}
                    </Button>
                </Reveal>
            </Box>
        </Box>
    );
};

export default HeroSection;
